import React from 'react';
import { Card, Icon, Dimmer, Loader } from 'semantic-ui-react';
import _ from 'lodash';

import { YOUTUBE, TWITTER, INSTAGRAM, FACEBOOK } from '../../utils/static-configuration';
import EmptyAssets from './empty-assets';
import AssetCard from '../asset-card';

const CampaignDashboardLoadingCard = () => (
  <Card>
    <Dimmer active inverted>
      <Loader size="small">Loading</Loader>
    </Dimmer>
  </Card>
);


const CampaignDashboardCards = props => {
  const {
    assets,
    viewMode,
    groupBy,
    isAddingNewCard,
    toggleAddAssetModalState,
    isLoading,
    isLoaded,
    hamburgerOptions,
  } = props;

  const shouldGroupByPlatform = groupBy === 'platform';
  const itemsPerRow = viewMode === 'cards.small' ? 6 : 4;

  const noAssets = assets.length === 0;

  if (shouldGroupByPlatform) {
    const groupedAssets = _.groupBy(assets, 'attributes.platform');
    return (
      <div>
        <h2><Icon name="facebook" />Facebook</h2>
        <Card.Group itemsPerRow={itemsPerRow}>
          { groupedAssets && _.map(groupedAssets[FACEBOOK], (asset =>
            <AssetCard
              key={asset.id}
              asset={asset.attributes.initialData.standardFormat}
              viewMode={viewMode}
            />))
          }
        </Card.Group>
        <h2><Icon name="twitter" />Twitter</h2>
        <Card.Group itemsPerRow={itemsPerRow}>
          {groupedAssets && _.map(groupedAssets[TWITTER], (asset =>
            <AssetCard
              key={asset.id}
              asset={asset.attributes.initialData.standardFormat}
              viewMode={viewMode}
            />))
          }
        </Card.Group>
        <h2><Icon name="instagram" />Instagram</h2>
        <Card.Group itemsPerRow={itemsPerRow}>
          {groupedAssets && _.map(groupedAssets[INSTAGRAM], (asset =>
            <AssetCard
              key={asset.id}
              asset={asset.attributes.initialData.standardFormat}
              viewMode={viewMode}
            />))
          }
        </Card.Group>
        <h2><Icon name="youtube" />Youtube</h2>
        <Card.Group itemsPerRow={itemsPerRow}>
          {groupedAssets && _.map(groupedAssets[YOUTUBE], (asset =>
            <AssetCard
              key={asset.id}
              asset={asset.attributes.initialData.standardFormat}
              viewMode={viewMode}
            />))
          }
        </Card.Group>
      </div>
    );
  }

  if (isLoaded && noAssets) return <EmptyAssets ctaHandler={toggleAddAssetModalState} />;

  return (
    <Card.Group itemsPerRow={itemsPerRow}>
      { assets && _.map(assets, (asset =>
        <AssetCard
          asset={asset}
          viewMode={viewMode}
          hamburgerOptions={hamburgerOptions}
        />))
      }
      { isAddingNewCard && <CampaignDashboardLoadingCard /> }
    </Card.Group>
  );
};

export default CampaignDashboardCards;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-dashboard-cards/index.js
 **/